import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_extkpy9afk: FaireBrandEntity = {
  token: "b_extkpy9afk",
  type: "brand",
  name: "Isatopia",
  avatarUrl:
    "https://cdn.faire.com/fastly/8558d7e02c3c328631d7ba77e67dfcbb96950f57d4f24bb83effb9a6e9d60915.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c990c1a6e6c02472c0161c3d6341f0888105721d3f30fd05dc4fcbee3052629a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8558d7e02c3c328631d7ba77e67dfcbb96950f57d4f24bb83effb9a6e9d60915.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c990c1a6e6c02472c0161c3d6341f0888105721d3f30fd05dc4fcbee3052629a.jpeg",
  location: "Belfast, ME, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 59,
  isTopShop: true,
  isInsider: true,
  description:
    "Isatopia is a creative studio offering lively illustrated products that bring a little magic into the everyday! \nIt was created by Isabelle Gelot, a French-born designer based in Maine, USA.\nBefore crossing the Atlantic, Isabelle spent a decade as a nomadic designer working with agencies in different parts of the world. As she traveled, she created Isatopia to share the sketches, patterns, and illustrated stories that came to her on the road.\nIsatopia became a shop featuring fun illustrated products designed by Isabelle out of her home studio on the rocky coast of Maine. Each creation is lovingly created to brighten up a home! Isabelle seeks to use sustainable materials whenever possible, and collaborates with local makers on American made products.\nWhen she is not in her studio, nothing makes her happier than swimming in cold water and feeling the fresh ocean air....\n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:13.842Z",
    importedBy: "entity-db-cli",
  },
};
